// src/pages/admin/branches/components/DeleteConfirmDialog.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    CircularProgress
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

const DeleteConfirmDialog = ({
    open,
    onClose,
    branch,
    onConfirm,
    loading
}) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={1}>
                    <WarningIcon color="error" />
                    {t('branches.confirmDelete', 'Confirm Delete')}
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {t('branches.deleteConfirmMessage', 'Are you sure you want to delete this branch?')}
                </Typography>
                {branch && (
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }}>
                        "{branch.name}"
                    </Typography>
                )}
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                    {t('common.deleteWarning', 'This action cannot be undone.')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    {t('common.cancel', 'Cancel')}
                </Button>
                <Button
                    onClick={() => onConfirm(branch?._id)}
                    color="error"
                    variant="contained"
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={18} />}
                >
                    {loading ? t('common.deleting', 'Deleting...') : t('common.delete', 'Delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;